var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-datasets-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-datasets-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-datasets-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-datasets-head" }, [
                _c("div", { staticClass: "wkb-datasets-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-datasets-title" } }, [
                    _vm._v("Find related datasets"),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "wkb-datasets-close",
                      attrs: {
                        type: "button",
                        "aria-label": "Close",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
                _c("p", { staticClass: "wkb-datasets-intro" }, [
                  _vm._v(
                    " Select genes on the canvas, then find CFDE gene sets linked to them. Results include overlap and enrichment-style scores for the top matches. "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "wkb-datasets-body" },
                [
                  !_vm.selectedGeneCount
                    ? _c("p", { staticClass: "wkb-datasets-empty" }, [
                        _vm._v(
                          " Mark one or more genes as selected on the canvas before finding related datasets. "
                        ),
                      ])
                    : [
                        _c("p", { staticClass: "wkb-datasets-helper" }, [
                          _vm._v(
                            " Using " +
                              _vm._s(_vm.selectedGeneCount) +
                              " selected gene" +
                              _vm._s(_vm.selectedGeneCount === 1 ? "" : "s") +
                              " for CFDE gene-set search. "
                          ),
                        ]),
                        _vm.resultRun
                          ? _c(
                              "section",
                              { staticClass: "wkb-datasets-results" },
                              [
                                _c("WorkspaceCfdeDatasetRunCard", {
                                  attrs: {
                                    run: _vm.resultRun,
                                    "current-active-set-key":
                                      _vm.currentActiveSetKey,
                                    "canvas-graph-node-ids":
                                      _vm.canvasGraphNodeIds,
                                    loading: _vm.loading,
                                    "graph-busy": _vm.graphBusy,
                                  },
                                  on: {
                                    refresh: function ($event) {
                                      return _vm.$emit("search")
                                    },
                                    "add-gene-set": function ($event) {
                                      return _vm.$emit("add-gene-set", $event)
                                    },
                                    "remove-gene-set": function ($event) {
                                      return _vm.$emit(
                                        "remove-gene-set",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm.selectedGeneCount && (_vm.showSearchForm || _vm.resultRun)
                ? _c("div", { staticClass: "wkb-datasets-actions" }, [
                    _vm.resultRun && !_vm.showSearchForm
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wkb-datasets-btn wkb-datasets-btn-secondary",
                            attrs: { type: "button", disabled: _vm.loading },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("search-again")
                              },
                            },
                          },
                          [_vm._v(" Find datasets again ")]
                        )
                      : _vm._e(),
                    _vm.showSearchForm
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wkb-datasets-btn wkb-datasets-btn-primary",
                            attrs: { type: "button", disabled: _vm.loading },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("search")
                              },
                            },
                          },
                          [_vm._v(" Find datasets ")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }